import type { ListProjectMaterialsParams } from '@amarantos/api-client'
import { MaterialProvenance } from '@amarantos/api-client'
import { z } from 'zod/v3'

export const materialProvenances = Object.values(MaterialProvenance)

export const provenanceFilterValues = ['all', ...materialProvenances] as const

const baseMaterialsSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	search: z.string().default(''),
	provenance: z.enum(provenanceFilterValues).default('all'),
})

// The tab's drawer keys on `dialog`, matching its sibling tabs: the project layout above it
// already owns `mode` for the report-review drawer.
const drawerSearchStateSchema = z.union([
	z.object({
		dialog: z.literal('create'),
		materialId: z.undefined().optional(),
	}),
	z.object({
		dialog: z.literal('edit'),
		materialId: z.coerce.number().int().positive(),
	}),
	z.object({
		dialog: z.undefined().optional(),
		materialId: z.undefined().optional(),
	}),
])

export const materialsSearchSchema = baseMaterialsSearchSchema.and(drawerSearchStateSchema)

export type MaterialsSearch = z.infer<typeof materialsSearchSchema>

export function toListProjectMaterialsParams(search: MaterialsSearch): ListProjectMaterialsParams {
	return {
		page: search.page,
		per_page: search.perPage,
		search: search.search.length > 0 ? search.search : undefined,
		provenance: search.provenance === 'all' ? undefined : search.provenance,
	}
}
